import { takeLatest, put, call } from 'redux-saga/effects';
import {
    FETCH_CALCULATION_PARAMETER_REQUEST, fetchCalculationParameterResponse, FETCH_CALCULATE_REVENUE_REQUEST,
    fetchCalculateRevenueResponse
} from './action';
import { REPORT } from '../../../../../config';
import { HTTP_HEADERS } from '../../../../../constants'
import request from "../../../../../components/Utils/httpHelper";

export function* fetchCalculationParameterRequest(action) {
    let requestURL = `${REPORT}/income/estimation/getparameters/${action.data}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchCalculationParameterResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchCalculationParameterResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* fetchCalculationParameterData() {
    yield takeLatest(FETCH_CALCULATION_PARAMETER_REQUEST, fetchCalculationParameterRequest);
}

export function* fetchCalculateRevenueRequest(action) {
    let requestURL = `${REPORT}/income/estimation/calculateincome/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { data: action.data.formData, method: 'POST', headers: HTTP_HEADERS });
        yield put(fetchCalculateRevenueResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchCalculateRevenueResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* fetchCalculateRevenueData() {
    yield takeLatest(FETCH_CALCULATE_REVENUE_REQUEST, fetchCalculateRevenueRequest);
}